import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * Get the data from the API or Use the data that is constant in the code
 */
@Injectable()
export class LeadTimesApiBlkAdt implements IFlagFeature {
  name = Features.LEAD_TIMES_API_BLK_ADT;

  public isEnabled(_container: IToggleContainer, _config: any): boolean {
    return true;
  }
}
